// extracted by mini-css-extract-plugin
module.exports = {"stats":"UserSummary_stats__bn4UQ","average":"UserSummary_average__3R9qg","record":"UserSummary_record__1dfcs"};